(function () {
  'use strict';

  function readBundleConfig(sectionEl) {
    return {
      sectionId: sectionEl.dataset.sectionId || '',
      bundleSize: Number(sectionEl.dataset.bundleSize || 0),
      discountCodes: String(sectionEl.dataset.discountCode || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean),
      sellingPlanId: Number(sectionEl.dataset.sellingPlanId || 0),
      slotLabel: sectionEl.dataset.slotLabel || 'Slot',
      showFreeSlot: sectionEl.dataset.showFreeSlot === 'true',
      variantPriceCents: Number(sectionEl.dataset.variantPriceCents || 0),
      currencyCode: sectionEl.dataset.currencyCode || 'USD',
    };
  }

  const sectionRoot = document.querySelector('.mgn-bundle[data-mgn-bundle-shop]');
  if (!sectionRoot) return;
  const cfg = readBundleConfig(sectionRoot);
  const SECTION_ID = cfg.sectionId;
  const BUNDLE_SIZE = cfg.bundleSize;
  const DISCOUNT_CODES = cfg.discountCodes;
  const SELLING_PLAN_ID = cfg.sellingPlanId;
  const SLOT_LABEL = cfg.slotLabel;
  const SHOW_FREE_SLOT = cfg.showFreeSlot;
  const VARIANT_PRICE_CENTS = cfg.variantPriceCents;
  const CURRENCY_CODE = cfg.currencyCode;

  const _pricingEl = document.getElementById(`bundleVariantPricing--${SECTION_ID}`);
  let VARIANT_PRICING = {};
  try {
    VARIANT_PRICING = _pricingEl ? JSON.parse(_pricingEl.textContent) : {};
  } catch (e) {
    console.warn('[BundleBuilder] Bad variant pricing JSON');
  }

  const _fmt = new Intl.NumberFormat('en-US', {
    style                : 'currency',
    currency             : CURRENCY_CODE || 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  const formatMoney = cents => _fmt.format(cents / 100);

  function getSectionConfig(sectionEl) {
    if (!sectionEl) {
      return {
        bogoUrlParamsEnabled: false,
        bogoUrlParams: '',
        checkoutUrl: '/checkout',
        giftCardAttrSubEnabled: false,
        giftCardAttrOtpEnabled: false,
        giftCardAmount: '',
      };
    }
    return {
      bogoUrlParamsEnabled: sectionEl.dataset.bogoUrlParamsEnabled === 'true',
      bogoUrlParams: sectionEl.dataset.bogoUrlParams || '',
      checkoutUrl: sectionEl.dataset.checkoutUrl || '/checkout',
      giftCardAttrSubEnabled: sectionEl.dataset.giftCardAttrSubEnabled === 'true',
      giftCardAttrOtpEnabled: sectionEl.dataset.giftCardAttrOtpEnabled === 'true',
      giftCardAmount: sectionEl.dataset.giftCardAttrAmount || '',
    };
  }

  function getPromoGiftItems(sectionEl) {
    if (!sectionEl || sectionEl.dataset.customPromoEnabled !== 'true') return [];
    var landingSource = (sectionEl.dataset.customPromoLandingSource || '').trim();
    var rawIds = (sectionEl.dataset.customPromoGiftIds || '').trim();
    if (!landingSource || !rawIds) return [];
    return rawIds.split(',').map(function (s) { return s.trim(); }).filter(Boolean).map(function (id) {
      return {
        id: Number(id),
        quantity: 1,
        properties: {
          _landing_source: landingSource,
          __landing_source: landingSource,
          _promo_gift: 'true',
        },
      };
    });
  }

  function attachPromoLandingSource(item, sectionEl) {
    if (!sectionEl || sectionEl.dataset.customPromoEnabled !== 'true') return item;
    var landingSource = (sectionEl.dataset.customPromoLandingSource || '').trim();
    if (!landingSource) return item;
    var next = Object.assign({}, item);
    next.properties = Object.assign({}, item.properties || {}, {
      _landing_source: landingSource,
      __landing_source: landingSource,
    });
    return next;
  }

  function normalizeBogoParamString(rawValue) {
    if (!rawValue) return '';
    let normalized = String(rawValue).trim();
    if (!normalized) return '';

    if (normalized.indexOf('://') !== -1) {
      try {
        normalized = new URL(normalized).search.replace(/^\?/, '');
      } catch (err) {}
    }

    const queryStartIndex = normalized.indexOf('?');
    if (queryStartIndex > -1) {
      normalized = normalized.slice(queryStartIndex + 1);
    }

    normalized = normalized.replace(/^[?&]+/, '');

    const hashIndex = normalized.indexOf('#');
    if (hashIndex > -1) {
      normalized = normalized.slice(0, hashIndex);
    }

    return normalized.trim();
  }

  function waitForBogoGift(knownItemCount) {
    return new Promise(function (resolve) {
      let elapsed = 0;
      const interval = 200;
      const maxWait = 3000;

      function check() {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(r => r.json())
          .then(cart => {
            if (cart.item_count > knownItemCount) {
              resolve(true);
            } else {
              elapsed += interval;
              if (elapsed >= maxWait) {
                resolve(false);
              } else {
                setTimeout(check, interval);
              }
            }
          })
          .catch(() => resolve(false));
      }

      setTimeout(check, interval);
    });
  }

  var CHECKOUT_REDIRECT_FLAG = '__oseddCheckoutRedirectUntil';

  function setCheckoutRedirectGuard(durationMs) {
    durationMs = durationMs || 6000;
    window[CHECKOUT_REDIRECT_FLAG] = Date.now() + Math.max(1000, Number(durationMs) || 6000);
  }

  function clearCheckoutRedirectGuard() {
    delete window[CHECKOUT_REDIRECT_FLAG];
  }

  function extractBogoCartAttributes(sectionEl) {
    const sectionConfig = getSectionConfig(sectionEl);
    const raw = normalizeBogoParamString(sectionConfig.bogoUrlParams);
    if (!raw) return null;
    const attrs = {};
    let hasAny = false;
    new URLSearchParams(raw).forEach((value, key) => {
      if (!key) return;
      attrs[key] = value;
      hasAny = true;
    });
    return hasAny ? attrs : null;
  }

  function applyBogoUrlParams(sectionEl, options) {
    const sectionConfig = getSectionConfig(sectionEl);
    const bogo = window.AmbrosiaBogoUrlParams;
    if (!bogo) return false;
    return bogo.apply(sectionConfig, options);
  }

  function mergeConfiguredBogoParams(checkoutUrl, sectionEl) {
    const sectionConfig = getSectionConfig(sectionEl);
    if (!sectionConfig.bogoUrlParamsEnabled) return;

    const sanitizedParams = normalizeBogoParamString(sectionConfig.bogoUrlParams);
    if (!sanitizedParams) return;

    const incomingParams = new URLSearchParams(sanitizedParams);
    incomingParams.forEach((value, key) => {
      if (!key) return;
      checkoutUrl.searchParams.set(key, value);
    });
  }

  function getCheckoutUrlWithCurrentParams(sectionEl, discountCodes) {
    const sectionConfig = getSectionConfig(sectionEl);
    const checkoutBase = sectionConfig.checkoutUrl || '/checkout';
    const checkoutUrl = new URL(checkoutBase, window.location.origin);
    const currentParams = new URLSearchParams(window.location.search);

    currentParams.forEach((value, key) => {
      checkoutUrl.searchParams.set(key, value);
    });

    mergeConfiguredBogoParams(checkoutUrl, sectionEl);

    if (discountCodes && discountCodes.length > 0) {
      checkoutUrl.searchParams.set('discount', discountCodes.join(','));
    }

    if (checkoutUrl.origin === window.location.origin) {
      return checkoutUrl.pathname + checkoutUrl.search + checkoutUrl.hash;
    }
    return checkoutUrl.toString();
  }

  function checkoutHrefWithDiscounts(sectionEl) {
    applyBogoUrlParams(sectionEl);
    return getCheckoutUrlWithCurrentParams(sectionEl, DISCOUNT_CODES);
  }

  class BundleBuilder {
    constructor() {
      this.items      = []; // [{ variantId, title, image }, ...]
      this.section    = document.querySelector(`.mgn-bundle--${SECTION_ID}`) || sectionRoot;
      this.countEl    = document.getElementById(`bundleCount--${SECTION_ID}`);
      this.slotsEl    = document.getElementById(`bundleSlots--${SECTION_ID}`);
      this.ctaEl      = document.getElementById(`bundleCta--${SECTION_ID}`);
      this.onceEl     = document.getElementById(`bundleBuyOnce--${SECTION_ID}`);
      this.compareEl  = document.getElementById(`bundleCompare--${SECTION_ID}`);
      this.priceEl    = document.getElementById(`bundlePrice--${SECTION_ID}`);
      this.saveEl     = document.getElementById(`bundleSave--${SECTION_ID}`);

      if (!this.section || !this.ctaEl) return;

      if (applyBogoUrlParams(this.section, { allowReload: true })) return;

      this._bindEvents();
    }

    /* ── Event wiring ──────────────────────────────────── */

    _bindEvents() {
      this.section.querySelectorAll('.bundle-card__btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const card = btn.closest('.bundle-card');
          if (!card || card.dataset.available === 'false' || btn.disabled) return;
          this._clearCartError();
          this._addItem({
            variantId : card.dataset.variantId,
            title     : card.dataset.variantTitle,
            image     : card.dataset.variantImage || ''
          });
        });
      });

      this.ctaEl.addEventListener('click', () => {
        if (this.items.length === BUNDLE_SIZE) this._submitCart(true);
      });

      if (this.onceEl) {
        this.onceEl.addEventListener('click', () => {
          if (this.items.length === BUNDLE_SIZE) this._submitCart(false);
        });
      }
    }

    _clearCartError() {
      const el = this.section.querySelector('[data-mgn-cart-error]');
      if (!el) return;
      el.textContent = '';
      el.setAttribute('hidden', '');
    }

    _showCartError(message) {
      const el = this.section.querySelector('[data-mgn-cart-error]');
      if (!el) return;
      el.textContent = message || 'Unable to add to cart. Please try again.';
      el.removeAttribute('hidden');
    }

    /* ── State mutations ───────────────────────────────── */

    _addItem(item) {
      if (this.items.length >= BUNDLE_SIZE) return;
      this.items.push(item);
      this._updateUI();
    }

    _removeItem(index) {
      this.items.splice(index, 1);
      this._updateUI();
    }

    /* ── UI sync ───────────────────────────────────────── */

    _updateUI() {
      const count     = this.items.length;
      const remaining = BUNDLE_SIZE - count;

      if (this.countEl) this.countEl.textContent = count;

      // Slots
      const slots = this.slotsEl.querySelectorAll('.basket__slot');
      slots.forEach((slot, i) => {
        const isFree = slot.dataset.free === 'true';
        const label  = slot.dataset.label || (isFree ? 'Free' : `${SLOT_LABEL} ${i + 1}`);
        const item   = this.items[i];

        if (item) {
          slot.classList.replace('basket__slot--empty', 'basket__slot--filled');
          slot.querySelector('.basket__slot-thumb').innerHTML = `
            ${item.image
              ? `<img src="${item.image}" alt="${item.title}" class="basket__slot-img">`
              : `<div style="width:100%;height:100%;background:#e8e8e8;"></div>`
            }
            <button class="basket__slot-remove" type="button" aria-label="Remove item">&times;</button>
          `;
          slot.querySelector('.basket__slot-remove').addEventListener('click', e => {
            e.stopPropagation();
            this._removeItem(i);
          });
        } else {
          slot.classList.replace('basket__slot--filled', 'basket__slot--empty');
          slot.querySelector('.basket__slot-thumb').innerHTML = `
            <span class="basket__slot-empty-text">${label.toUpperCase()}</span>
          `;
        }
      });

      // Subscribe CTA — only enabled when the full bundle is selected
      if (count === BUNDLE_SIZE) {
        this.ctaEl.textContent = this.section.dataset.ctaLabel || 'CHECKOUT';
        this.ctaEl.classList.add('basket__cta--ready');
        this.ctaEl.classList.remove('basket__cta--loading');
      } else {
        const remaining  = BUNDLE_SIZE - count;
        const labelWord  = remaining === 1 ? SLOT_LABEL.toUpperCase() : `${SLOT_LABEL.toUpperCase()}S`;
        this.ctaEl.textContent = `SELECT ${remaining} MORE ${labelWord}`;
        this.ctaEl.classList.remove('basket__cta--ready', 'basket__cta--loading');
      }

      // Buy It Once enabled only when bundle is full
      if (this.onceEl) this.onceEl.disabled = count < BUNDLE_SIZE;

      /*this._updatePricing(count);*/
      this._syncCards(count);
    }

    _updatePricing(count) {
      if (!this.priceEl) return;

      // Last slot is free only when the full bundle is filled (subscription UX)
      const hasFreeSlot = SHOW_FREE_SLOT && count === BUNDLE_SIZE;

      let compareCents = 0;
      let subCents     = 0;

      this.items.forEach((item, idx) => {
        const row = VARIANT_PRICING[item.variantId] || VARIANT_PRICING[String(item.variantId)];
        const otp = row && typeof row.otp === 'number' ? row.otp : VARIANT_PRICE_CENTS;
        const sub = row && typeof row.sub === 'number' ? row.sub : otp;
        compareCents += otp;

        const isFreeSlot = hasFreeSlot && idx === count - 1;
        // Free gift slot: $0 in displayed total (Shopify discount zeroes the extra line in cart/checkout)
        if (!isFreeSlot) subCents += sub;
      });

      const savedCents = compareCents - subCents;
      const savingsPct = compareCents > 0 ? Math.round((savedCents / compareCents) * 100) : 0;

      // Price (always visible)
      this.priceEl.textContent = formatMoney(subCents);

      // Compare-at (only when there's a real saving to show)
      if (this.compareEl) {
        const showCompare = count > 0 && savedCents > 0;
        this.compareEl.textContent  = formatMoney(compareCents);
        this.compareEl.style.display = showCompare ? '' : 'none';
      }

      // Savings badge
      if (this.saveEl) {
        const showSave = count > 0 && savingsPct > 0;
        this.saveEl.textContent  = `SAVE ${savingsPct}%`;
        this.saveEl.style.display = showSave ? '' : 'none';
      }
    }

    _syncCards(count) {
      const tally = {};
      this.items.forEach(item => {
        tally[item.variantId] = (tally[item.variantId] || 0) + 1;
      });

      this.section.querySelectorAll('.bundle-card').forEach(card => {
        const vid       = card.dataset.variantId;
        const cardCount = tally[vid] || 0;
        const btn       = card.querySelector('.bundle-card__btn');
        const soldOut   = card.dataset.available === 'false';

        if (soldOut) {
          btn.textContent = 'Sold out';
          btn.disabled = true;
        } else {
          btn.textContent = cardCount > 0 ? `Add (${cardCount})` : 'Add';
          btn.disabled = count >= BUNDLE_SIZE;
        }
        card.classList.toggle('bundle-card--in-bundle', cardCount > 0);
      });
    }

    /* ── Cart submission ───────────────────────────────── */

    async _submitCart(withSubscription) {
      this._clearCartError();
      if (this.items.length !== BUNDLE_SIZE) return;

      applyBogoUrlParams(this.section);

      const btn = withSubscription ? this.ctaEl : this.onceEl;
      const originalText = btn.textContent;
      btn.textContent = 'Adding\u2026';
      if (withSubscription) {
        this.ctaEl.classList.replace('basket__cta--ready', 'basket__cta--loading');
      }
      if (this.onceEl) this.onceEl.disabled = true;

      // Paid slots: section selling plan. Last slot when show_free_slot: one-time (no plan).
      const bucketQty = new Map();
      this.items.forEach((item, idx) => {
        const useSellingPlan =
          withSubscription &&
          SELLING_PLAN_ID &&
          this.items.length === BUNDLE_SIZE &&
          !(SHOW_FREE_SLOT && idx === BUNDLE_SIZE - 1);
        const key = `${item.variantId}:${useSellingPlan ? 'sub' : 'otp'}`;
        bucketQty.set(key, (bucketQty.get(key) || 0) + 1);
      });

      const cartItems = Array.from(bucketQty.entries()).map(([key, qty]) => {
        const [idStr, mode] = key.split(':');
        const entry = attachPromoLandingSource({ id: parseInt(idStr, 10), quantity: qty }, this.section);
        if (mode === 'sub') entry.selling_plan = SELLING_PLAN_ID;
        return entry;
      });
      // Append custom promo gift items
      getPromoGiftItems(this.section).forEach(function (g) { cartItems.push(g); });

      try {
        if (!window.AmbrosiaFastCheckout) throw new Error('Checkout helper failed to load');
        const shouldClearCart = this.section.dataset.clearCart !== 'false';
        await window.AmbrosiaFastCheckout.addThenCheckout({
          sectionConfig: getSectionConfig(this.section),
          clearCart: shouldClearCart,
          items: cartItems,
          waitForGift: getSectionConfig(this.section).bogoUrlParamsEnabled,
          isSubscription: !!withSubscription,
          discountCodes: DISCOUNT_CODES,
        });
      } catch (err) {
        console.error('[BundleBuilder] Cart error:', err);
        this._showCartError(err && err.message ? err.message : 'Unable to add to cart. Please try again.');
        btn.textContent = 'Error \u2014 Try Again';
        if (withSubscription) {
          this.ctaEl.classList.replace('basket__cta--loading', 'basket__cta--ready');
        }
        if (this.onceEl) this.onceEl.disabled = false;
        if (window.AmbrosiaFastCheckout) window.AmbrosiaFastCheckout.endRedirecting();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new BundleBuilder());
  } else {
    new BundleBuilder();
  }
})();
